import { motion } from 'framer-motion'
import { useFeatureNavigation } from '../hooks/useFeatureNavigation'

const FeatureProgressDots = () => {
  const { currentIndex, totalPages, navigateToIndex, getFeatureName } = useFeatureNavigation()

  return (
    <div className="fixed bottom-8 left-0 right-0 z-40 flex justify-center pointer-events-none">
      <div className="pointer-events-auto bg-black/80 backdrop-blur-xl border border-white/10 rounded-full px-6 py-3 shadow-2xl">
        <div className="flex items-center gap-3">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => navigateToIndex(index)}
              className="group relative"
              aria-label={`Go to ${getFeatureName(index)}`}
            >
              <motion.div
                initial={false}
                animate={{
                  scale: currentIndex === index ? 1.4 : 1,
                  backgroundColor: currentIndex === index ? '#3b82f6' : '#6b7280',
                }}
                transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                className="w-2 h-2 rounded-full cursor-pointer"
              />
              
              {/* Tooltip on hover */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-black/95 text-white text-xs rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                {getFeatureName(index)}
                <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-black/95"></div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeatureProgressDots
